import cn from "classnames";
import { NextPage } from "next";
import { Html } from "next/document";
import Head from "next/head";
import { useRouter } from "next/router";
import { ReactNode } from "react";
import { isNoIndexPath } from "src/utils/seo";

import Footer from "../Footer";
import Navbar from "../Navbar";

export interface LayoutProps {
  children: ReactNode;
  banner?: boolean;
  footer?: boolean;
  bottomNavigation?: boolean;
  isLoading?: boolean;
  description?: string;
  searchBar?: boolean;
  title?: string;
  withoutHeaderAndFooter?: boolean;
  headlines?: boolean;
  selected?: "home" | "wallet" | "cart" | "profile" | undefined;
  FooterComponent?: ReactNode;
  HeaderComponent?: ReactNode;
}
export interface OptionsType {
  headlines?: boolean;
  FooterComponent?: ReactNode;
  HeaderComponent?: ReactNode;
  footer?: boolean;
  searchBar?: boolean;
  bottomNavigation?: boolean;
  title?: string;
  description?: string;
  selected?: "home" | "wallet" | "cart" | "profile" | undefined;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title = "Dadbanan",
  footer = true,
  description,
  FooterComponent,
  HeaderComponent,
  withoutHeaderAndFooter = false,
  headlines = false,
}) => {
  const router = useRouter();
  const noIndex = isNoIndexPath(router.asPath || router.pathname || "");

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />

        <meta
          name="sabavision_advertiser_id"
          content="7e974709-cbd8-4943-a622-00fb1c0e2609"
        />
        <meta name="theme-color" content="#37bfb4" />

        <meta name="apple-mobile-web-app-capable" content="yes" />

        <meta name="apple-mobile-web-app-status-bar-style" content="#37bfb4" />
        <meta
          name="robots"
          content={noIndex ? "noindex, nofollow" : "index, follow"}
        />

        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/favicon/apple-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href="/favicon/apple-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/favicon/apple-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/favicon/apple-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/favicon/apple-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/favicon/apple-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/favicon/apple-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/favicon/apple-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicon/apple-icon-180x180.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href="/favicon/android-icon-192x192.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href="/favicon/favicon-96x96.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon/favicon-16x16.png"
        />
        <link rel="manifest" href="manifest.json" />

        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
                <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script> */}
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta
          name="msapplication-TileImage"
          content="/favicon/ms-icon-144x144.png"
        />
        <meta name="theme-color" content="#ffffff" />
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
        />

        <script
          async
          src="https://s1.mediaad.org/serve/119413/retargeting.js"
        />
        {/*<script*/}
        {/*  src={*/}
        {/*    "https://van.najva.com/static/js/scripts/new-website656801-website-44131-14eaee2f-7b1d-409e-9c51-d0845525eb02-service-worker.js"*/}
        {/*  }*/}
        {/*  async*/}
        {/*/>*/}
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `!function(){function t(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,localStorage.getItem("rayToken")?t.src="https://app.raychat.io/scripts/js/"+o+"?rid="+localStorage.getItem("rayToken")+"&href="+window.location.href:t.src="https://app.raychat.io/scripts/js/"+o+"?href="+window.location.href;var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e)}var e=document,a=window,o="93bf51a8-db2f-42da-8234-4b629f0e7b6d";"complete"==e.readyState?t():a.attachEvent?a.attachEvent("onload",t):a.addEventListener("load",t,!1)}();`,
          }}
        />
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}');`,
          }}
        />
        {/*<script*/}
        {/*  async*/}
        {/*  src={`https://plus.sabavision.com/dmp/dox/events.min.js`}*/}
        {/*/>*/}

        {/*<script async>{`__SabaEvents.initialize()`}</script>*/}

        {/*<script*/}
        {/*  async*/}
        {/*  dangerouslySetInnerHTML={{*/}
        {/*    __html: `(function(){*/}
        {/*                var now = new Date();*/}
        {/*                var version = now.getFullYear().toString() + "0" + now.getMonth() + "0" + now.getDate() +*/}
        {/*                "0" + now.getHours();*/}
        {/*                var head = document.getElementsByTagName("head")[0];*/}
        {/*                var link = document.createElement("link");*/}
        {/*                link.rel = "stylesheet";*/}
        {/*                link.href = "https://van.najva.com/static/cdn/css/local-messaging.css" + "?v=" + version;*/}
        {/*                head.appendChild(link);*/}
        {/*                var script = document.createElement("script");*/}
        {/*                script.type = "text/javascript";*/}
        {/*                script.async = true;*/}
        {/*                script.src = "https://van.najva.com/static/js/scripts/new-website656801-website-44131-14eaee2f-7b1d-409e-9c51-d0845525eb02.js" + "?v=" + version;*/}
        {/*                head.appendChild(script);*/}
        {/*                })();`,*/}
        {/*  }}*/}
        {/*/>*/}
      </Head>

      {withoutHeaderAndFooter ? (
        children
      ) : (
        // <div className="h-screen w-full">
        <div className="bg-gray-250 relative mx-auto flex h-full w-full max-w-8xl flex-col justify-between">
          <div
            style={{ minHeight: "inherit" }}
            className="flex h-full flex-col"
          >
            <>
              {/* <div className="md:hidden"></div> */}
              <div className="block" style={{ flex: "0 1 auto" }}>
                {HeaderComponent ? HeaderComponent : <Navbar />}
              </div>
            </>

            <main
              style={{ flex: "1 1 auto" }}
              className={cn("bg-gray-250 mx-auto h-auto w-full md:pb-0")}
            >
              {children}
            </main>
            {footer && FooterComponent ? (
              FooterComponent
            ) : (
              <div style={{ flex: "0 1 auto" }}>
                <Footer />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export const getLayout = (page: NextPage, options: OptionsType) => (
  <Layout {...options}>{page}</Layout>
);
export default Layout;
